import  NetworkHandler from 'utils/network';
import config from 'config';

function getUserInfor(id) {
    return NetworkHandler.get(`${config.getUrl('admin_client', 2)}`,{
        params: {
            id
        }
    },'v2-api');
}
function getUserByPhone(phone) {
    return NetworkHandler.post(`${config.getUrl('admin_client', 2)}s`, {
        keyword:phone
    },null
    ,'v2-api');
}
function getBusUserInfo() {
    return NetworkHandler.get(`${config.getUrl('bus_staff')}/me`);
}

export default {
    getUserInfor,
    getUserByPhone,
    getBusUserInfo
};